import React, { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import type { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router'

import { FRONT_PAGE_OFFERS_TYPES } from 'constants/offerList'
import TextButton from 'LuxKit/Button/TextButton'
import useOfferList from 'hooks/Offers/useOfferList'
import GeoContext from 'contexts/geoContext'
import { take } from 'lib/array/arrayUtils'
import OfferListOfferTile from 'components/OfferList/OfferListTiles/OfferListOfferTile'
import PromptCardSelector from 'components/Common/StickyPromptCard/PromptCardSelector'
import ErrorBoundary from 'components/Common/ErrorBoundary/ErrorBoundary'

const Buttons = styled.div`
  margin-top: ${rem(40)};
  text-align: center;

  * + * {
    margin-left: ${rem(20)};
  }
`

interface Props extends RouteComponentProps<{ pageNum: string }> {
}

export function PaginatedOffersPage(props: Props) {
  const intl = useIntl()
  const { match } = props
  const { currentRegionCode } = useContext(GeoContext)

  const pageNum = useMemo(() => parseInt(match.params.pageNum), [match.params.pageNum])

  const filters = useMemo((): App.OfferListFilters => {
    return {
      offerTypes: FRONT_PAGE_OFFERS_TYPES(currentRegionCode),
    }
  }, [currentRegionCode])

  const offerList = useOfferList(filters)

  const endOfferIndex = pageNum * 12
  const hasMore = endOfferIndex < offerList.offerIds.length
  const offersToShow = take(offerList.offerIds, 12, (pageNum - 1) * 12)

  return <div>
    <ErrorBoundary fallback={null}>
      <PromptCardSelector tripReengagement />
    </ErrorBoundary>
    {offersToShow.map((id, index) => <OfferListOfferTile
      key={id}
      offerId={id}
      position={index}
      tileStyle="frontpage"
    />)}
    <Buttons>
      {pageNum > 1 &&
        <TextButton kind="primary" to={`/page/${pageNum - 1}`} rel="prev">
          {intl.formatMessage({
            id: 'CJSIgxqApc',
            defaultMessage: 'Previous',
            description: 'Button to navigate to the previous page of offers',
          })}
        </TextButton>}

      {hasMore &&
        <TextButton kind="primary" to={`/page/${pageNum + 1}`} rel="next">
          {intl.formatMessage({
            id: 'bOuJcOUlSd',
            defaultMessage: 'Next',
            description: 'Button to navigate to the next page of offers',
          })}
        </TextButton>}
    </Buttons>
  </div>
}

export default withRouter(PaginatedOffersPage)
